// Byd.js
/**
 * @description 系统判断工具类
 * @function 用于识别当前运行环境 (iOS / Android / HarmonyOS)
 * @returns {boolean}
 */
const getSystem = {
	isIOS() {
		const ua = navigator.userAgent || navigator.userAgent.toLowerCase()
		return /iPhone|iPad|iPod/i.test(ua) && !/Windows/i.test(ua)
	},
	isAndroid() {
		const ua = navigator.userAgent || navigator.userAgent.toLowerCase()
		return /Android/i.test(ua) && !/Windows/i.test(ua)
	},
	isHarmonyOS() {
		const ua = navigator.userAgent || navigator.userAgent.toLowerCase()
		return /Harmony/i.test(ua)
	},
}

/**
 * @description 格式化处理API传参
 * @data android/harmony--JSON.stringify(data)   ios--data
 * @returns
 */
function formatBridgeParams(data) {
	return getSystem.isIOS() ? data : JSON.stringify(data)
}

/**
 * @description 格式化处理桥接方式
 * @param {data} android/harmony--window.bydbridge ios--bydbridge
 * @returns
 */
export function getBridge() {
	// eslint-disable-next-line no-undef
	return getSystem.isIOS() ? bydbridge : window.bydbridge
}

/**
 * @description 格式化处理API调用
 * @param {*} name--API名称
 * @param {*} data--传参
 * @param {*} callback--API回调
 * @returns
 */
function callBridge(name, data = {}, options = {}) {
	const bridge = getBridge()
	if (!bridge) {
		console.log(`${name}未定义`)
		return
	}
	const { success, fail } = options
	bridge.call(name, formatBridgeParams(data), res => {
		const { code, msg } = res
		const data = typeof res.data === 'string' && res.data !== '' ? JSON.parse(res.data) : res.data
		if (code === 200 || code === 0) {
			success?.({ code, msg, data })
		} else {
			fail?.({ code, msg, error: new Error(msg || '调用失败') })
		}
	})
}

/**
 * @description 获取 URL 参数
 * @params {hideNavBar: 1,needAuthCode:1 }
 */
function getUrlParams() {
	if (window.URLSearchParams) {
		const res = new URLSearchParams(window.location.search)
		const result = {}
		for (const [key, value] of res.entries()) {
			result[key] = value
		}
		return params
	}
	const search = window.location.search || window.location.hash.split('?')[1] || ''
	const params = {}
	const regex = /[?&]([^=]+)=([^&]*)/g
	let match
	while ((match = regex.exec(search)) !== null) {
		params[match[1]] = decodeURIComponent(match[2])
	}
	return params
}

/**
 * description 具体方法调用
 */
const Byd = {
	getSystem,
	getUrlParams,
	showToast(data, options) {
		return callBridge('showToast', data, options)
	},
	navigateBack(options) {
		return callBridge('navigateBack', {}, options)
	},
	openShare(data, options) {
		return callBridge('openShare', data, options)
	},
	trackEvent(data, options) {
		return callBridge('trackEvent', data, options)
	},
	getSystemInfo(data, options) {
		return callBridge('getSystemInfo', data, options)
	},

	checkPermissions(data, options) {
		return callBridge('checkPermissions', data, options)
	},
	requestPermissions(data, options) {
		return callBridge('requestPermissions', data, options)
	},
	getLocationSwitchStatus(options) {
		return callBridge('getLocationSwitchStatus', {}, options)
	},
	openLocation(data, options) {
		return callBridge('openLocation', data, options)
	},
	getUserInfo(data, options) {
		return callBridge('getUserInfo', data, options)
	},
	getUserDefaultVehicleInfo(data, options) {
		return callBridge('getUserDefaultVehicleInfo', data, options)
	},
	request(data, options) {
		return callBridge('request', data, options)
	},
	navigateToMPaas(data, options) {
		return callBridge('navigateToMPaas', data, options)
	},
	navigateToNative(data, options) {
		return callBridge('navigateToNative', data, options)
	},
	invokeAppTask(data, options) {
		return callBridge('invokeAppTask', data, options)
	},
	navigateToMiniProgram(data, options) {
		return callBridge('navigateToMiniProgram', data, options)
	},
	getPrivacyAgreeStatus(data, options) {
		return callBridge('getPrivacyAgreeStatus', data, options)
	},
	getOnlineServiceProductInfo(data, options) {
		return callBridge('getOnlineServiceProductInfo', data, options)
	},
	getTencentIMLoginInf(data, options) {
		return callBridge('getTencentIMLoginInf', data, options)
	},
	navigateToBrowser(data, options) {
		return callBridge('navigateToBrowser', data, options)
	},
	getLocationInfoSilent(data, options) {
		return callBridge('getLocationInfoSilent', data, options)
	},
}
export default Byd
